import FingerprintRoundedIcon from '@mui/icons-material/FingerprintRounded';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';

export const METHOD_TYPES = [
  {
    key: 'otp',
    types: ['otp'],
    label: 'dashboard.accountSettings.twoStepVerification.methods.otp.label',
    name: 'dashboard.accountSettings.twoStepVerification.methods.otp.name',
    description: 'dashboard.accountSettings.twoStepVerification.methods.otp.description',
    Icon: FingerprintRoundedIcon,
  },
  {
    key: 'sms',
    // A phone factor set to voice is still the user's phone, so it shows (and can be removed) here.
    types: ['sms', 'voice'],
    label: 'dashboard.accountSettings.twoStepVerification.methods.sms.label',
    name: 'dashboard.accountSettings.twoStepVerification.methods.sms.name',
    description: 'dashboard.accountSettings.twoStepVerification.methods.sms.description',
    Icon: PhoneIphoneRoundedIcon,
  },
  {
    key: 'passkey',
    types: ['passkey', 'webauthn-platform', 'webauthn-roaming'],
    label: 'dashboard.accountSettings.twoStepVerification.methods.passkey.label',
    name: 'dashboard.accountSettings.twoStepVerification.methods.passkey.name',
    description: 'dashboard.accountSettings.twoStepVerification.methods.passkey.description',
    Icon: LockRoundedIcon,
  },
];

// A factor of any other type (e.g. "guardian", "push") has no row, so it can't be shown or removed.
export const RENDERED_METHOD_TYPES = new Set(METHOD_TYPES.flatMap(({ types }) => types));
